import { action } from 'typesafe-actions';
import { ResponseModalObject } from '../../utils/commonInterfaces';
import {
    CompaniesActionTypes,
    CompanyUserRole,
    SystemConfiguration,
    WorkflowOption,
} from './types';

/**
 * Actions for getting the user companies,
 * this includes company user roles.
 */
export const getUserCompaniesRequestAction = () =>
    action(CompaniesActionTypes.GET_USER_COMPANIES_REQUEST);
export const getUserCompaniesSuccessAction = (data: CompanyUserRole[]) =>
    action(CompaniesActionTypes.GET_USER_COMPANIES_SUCCESS, data);

/**
 * Actions triggered to determine which company the user has selected - for UI manipilation
 * since all API calls depend on the Company saved at cognito and not here.
 * @param companyUserRoleObject
 */
// export const selectUserCompanyRequestAction = (
//     companyUserRoleObject: CompanyUserRole,
//     callback?: () => void
// ) =>
//     action(CompaniesActionTypes.SELECT_USER_COMPANY_REQUEST, {
//         companyUserRoleObject,
//         callback,
//     });

// export const selectUserCompanySuccessAction = (
//     selectedCompany: CompanyUserRole
// ) => action(CompaniesActionTypes.SELECT_USER_COMPANY_SUCCESS, selectedCompany);

/**
 * Actions called for saving company data.
 * @param payload
 * @param callback - function called after saving - useful for refetching the company details
 * and showing alert modals
 */
export const saveUserCompanyRequestAction = (
    payload: any,
    callback?: (response: ResponseModalObject) => void
) =>
    action(CompaniesActionTypes.SAVE_USER_COMPANY_REQUEST, {
        payload,
        callback,
    });
export const saveUserCompanyResponseAction = () =>
    action(CompaniesActionTypes.SAVE_USER_COMPANY_RESPONSE);

/**
 * Action called for uploading company logo.
 * @param fileToUpload
 * @param callback - function called after saving and used for showing modal response
 */
// export const uploadCompanyLogoRequestAction = (
//     fileToUpload: any,
//     callback: (response: ResponseModalObject) => void
// ) =>
//     action(CompaniesActionTypes.UPLOAD_COMPANY_LOGO_REQUEST, {
//         fileToUpload,
//         callback,
//     });

/**
 * Action responsible for getting the system configuration.
 * To control the banner at the page header showing what mode the system is in.
 * Dev, Production, Test, and such.
 * @param data
 */
// export const getSystemConfigurationSuccessAction = (
//     data: SystemConfiguration
// ) => action(CompaniesActionTypes.GET_SYSTEM_CONFIGURATION_SUCCESS, data);

/**
 * Action that resets all company table data filters and sort values to initial state.
 */
// export const resetAllCompanyDataTableFiltersAction = () =>
//     action(CompaniesActionTypes.RESET_ALL_COMPANY_DATA_TABLE_FILTERS);

/**
 * Actions responsible for getting the workflow names for the company.
 */
export const getCompanyWorkflowOptionsRequestAction = (
    companyIds: string[] | undefined = undefined,
    isOrgView: boolean = false
) =>
    action(CompaniesActionTypes.GET_COMPANY_WORKFLOW_OPTIONS_REQUEST, { companyIds, isOrgView });
    
export const getCompanyWorkflowOptionsSuccessAction = (
    workflowOptions: WorkflowOption[]
) =>
    action(
        CompaniesActionTypes.GET_COMPANY_WORKFLOW_OPTIONS_SUCCESS,
        workflowOptions
    );
/**
 * Actions set loading status for the company for other states.
 */
export const setLoadingCompanyAction = (payload: boolean) =>
    action(CompaniesActionTypes.SET_COMPANY_LOADING_DATA, payload);

// /**
//  * Action for getting the custom field changes list.
//  * @param payload
//  */
export const getCustomFieldsChangesRequestAction = (
    payload: any,
    callback: (response: ResponseModalObject) => void
) =>
    action(CompaniesActionTypes.GET_CUSTOM_FIELDS_CHANGES_REQUEST, {
        payload,
        callback,
    });

/**
 * Actions called for saving user settings data.
 * @param payload
 * @param callback - function called after saving - useful for refetching the company details
 * and showing alert modals
//  */
export const saveCompanyUserSettingsRequestAction = (
    payload: any,
    callback?: (response: ResponseModalObject) => void
) =>
    action(CompaniesActionTypes.SAVE_COMPANY_USER_SETTINGS_REQUEST, {
        payload,
        callback,
    });
export const saveCompanyUserSettingsResponseAction = () =>
    action(CompaniesActionTypes.SAVE_COMPANY_USER_SETTINGS_RESPONSE);



export const getConveraCredentialsForCompanyRequestAction = (callback?: (res: any) => void) => ({
    type: CompaniesActionTypes.GET_CONVERA_CREDENTIALS_FOR_COMPANY_REQUEST,
    payload: { callback }
});